/** Matches API `TechnicalCompetenceSchemeDetailApiModel` / `RegTechnicalCompetence` JSON (camelCase). */
export interface ITechnicalCompetenceSchemeDetail {
    id: string;
    code: string;
    description: string | null;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export type TechnicalCompetenceSchemeCreatePayload = {
    code: string;
    description?: string | null;
    isActive?: boolean;
};

export type TechnicalCompetenceSchemeUpdatePayload = {
    id: string;
    code: string;
    description?: string | null;
};

export const TECHNICAL_COMPETENCE_SCHEME_CREATE_CONFLICT = {
    deletedRestoreAvailable: "technicalCompetence.deletedRestoreAvailable",
    duplicateActive: "technicalCompetence.duplicateActive",
} as const;
